import React , {useState} from 'react';
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux';
import styles from './product-row.scss';
import MoreMenu from 'jd-library/MoreMenu';
import withRipple from 'jd-library/withRipple';
import {shareProduct} from 'jd-library/shareUtills';
import { deleteProduct, productUnderEdit, toggleProductVisibility } from '../../actions/products';
import { showToastMessage } from '../../actions/toastmessage';
import SearchText from '../../common/SearchText';

const ProductRowVendor = props => {
    let productData = props.productData;
    if(props.objectionableMode && props.objectionableProducts){
        productData = props.objectionableProducts.find(product => product.id == props.variantId);
    }
    const [reverseAnimate, updateReverse] = useState(false);

    const history = useHistory();
    
    const renderSellingPrice = () => {
        if (
            productData.sellingPrice &&
            ['0', '0.0', '0.00'].indexOf(productData.sellingPrice) === -1
        ) {
            return true;
        } else {
            return false;
        }
    };

    const isSellingPrice = renderSellingPrice();
    const shareProductFunction = () => {
        let modalobj = {
            onYesClick: () => {
                props.toggleProductVisibility({
                    productId: productData.productId,
                    variantId: productData.variantId,
                    visibility: productData.visibility == "hide"?"unhide":"hide"
                });
                props.toggleModal(false);
                shareProduct({
                    productName:productData.productName,
                    companyName:props.session.companyName,
                    variantId:productData.variantId,
                    baseUrl:props.session.baseUrl,
                    isIosApp:false,
                    isaService:productData.type == 'SERVICE',
                    isSellOnline:productData.isSellOnline,
                    sendEnquiry:productData.isReceiveEnquiry
                });
            },
            onNoClick: () => {
                props.toggleModal(false);
            }
        }
        if(productData.visibility == "hide"){
            props.getModalObj(modalobj);
            props.toggleModal(true);

        } else {
           // props.getModalObj(modalobj);
            shareProduct({
                productName:productData.productName,
                companyName:props.session.companyName,
                variantId:productData.variantId,
                baseUrl:props.session.baseUrl,
                isIosApp:false,
                isaService:productData.type == 'SERVICE',
                isSellOnline:productData.isSellOnline,
                sendEnquiry:productData.isReceiveEnquiry
            });
        }
    }
    const editProduct = () => {
        // ProductIframeCommunication.editProductInCMS({
		// 	appType: 'customerApp',
		// 	pageType: 'edit',
		// 	productId: productData.productId,
		// 	variantId: productData.variantId,
		// 	productType: productData.templatingType,
		// 	clickOn: 'proddesc',
		// 	module: productData.type == 'SERVICE' ? 'service' : 'product',
		// 	page: 'listing',
		// 	event: null,
		// 	productCB: window.productCB,
		// 	href: '' //this.detailsPageUrl
        // });
        props.fetchDataAndEdit({
            itemId: productData.productId,
            cb: () => {
                history.push('/edit-item/'+productData.productId);
            }
        });
    };

    const listIconStyle = {fontSize: '0.75rem',marginRight: '10px'};
    let list = [
        {
            label: <span><i className='icon-editItem' style={listIconStyle}></i>Edit</span>,
            onClick: () => {
                if(productData.variantStatus) {
                    props.toggleNoEditModal(true);
                } else {
                    editProduct();
                }
            }
        }, {
        label: <span><i className={productData.visibility == "hide"?'icon-show':'icon-glhide'} style={listIconStyle}></i>{productData.visibility == "hide"? 'Unhide':'Hide'}</span>,
            onClick: () => {
                if(productData.visibility == "hide") {
                    updateReverse(true);
                    setTimeout(() => {
                        props.toggleProductVisibility({
                            productId: productData.productId,
                            variantId: productData.variantId,
                            visibility: productData.visibility == "hide"?"unhide":"hide"
                        });
                        updateReverse(false);
                        props.showToastMessage({
                            showToastMessage: true,
                            message: 'Product Status Updated',
                            duration: 1000
                        })    
                    }, 300);

                } else {
                    props.toggleProductVisibility({
                        productId: productData.productId,
                        variantId: productData.variantId,
                        visibility: productData.visibility == "hide"?"unhide":"hide"
                    });
                    props.showToastMessage({
                        showToastMessage: true,
                        message: 'Product Status Updated',
                        duration: 1000
                    })
                }

            }
        }, {
            label: <span><i className='icon-glshare' style={listIconStyle}></i>Share</span>,
            onClick: event => {
                //open share modal
                shareProductFunction();
            }
        }, {
            label: <span><i className='icon-trash' style={listIconStyle}></i>Delete</span>,
            onClick: event => {
                // props.deleteProduct(productData.variantId,()=>{},productData.productId);
                // props.showToastMessage({
                //     showToastMessage: true,
                //     message: productData.productName+" Deleted",
                //     duration: 1000
                // })
                props.confirmDelete(productData);
            }
        }
    ];

    if(props.objectionableMode){
        list = [{
            label: <span>Delete</span>,
            onClick: event => {
                props.confirmDelete(productData);
            }
        }]
    }

    const displayPrice = () => {
        const hiddenUoms = ['Unit','Packet','Piece'];
        if(productData.isSellOnline && isSellingPrice) {
            return (
                <span className={styles['product-price']}>
                    <span style={{fontSize: '1rem'}}>
                        <i className="icon-currencyB" />
                            {' ' +
                            Number(
                                productData.sellingPrice
                            ).toLocaleString()}
                    </span>
                </span>
            )
        } else if(productData.isReceiveEnquiry) {
            if(productData.activetab == "PRICERANGE" && (productData.minPrice && productData.maxPrice)) {
                return (
                    <span className={styles['price-range']}>
                    <span className={styles['product-price']}>
                        <i className="icon-currencyB" />{ ' '+ Number(
                                    productData.minPrice
                                ).toLocaleString()+' - '}
                        <i className="icon-currencyB" />
                            {' '+Number(
                                    productData.maxPrice
                                ).toLocaleString()}
                        </span>
                         {hiddenUoms.indexOf(props.getUom(productData.uom,true)) == -1 ? 
                        <span style={{color:'#717171'}}>{' / '+props.getUom(productData.uom,true)}</span>:
                        null}

                    </span>
                )
            } else if(productData.activetab == "PRICEFORSINGLEUNIT" && productData.enquiryPrice){
                return (
                    <span className={styles['product-price']}>
                        <span style={{fontSize: '1rem'}}>
                            <i className="icon-currencyB" />
                                {' ' +
                                Number(
                                    productData.enquiryPrice
                                ).toLocaleString()}
                        </span>
                        {hiddenUoms.indexOf(props.getUom(productData.uom,true)) == -1 ? 
                        <span style={{color:'#717171'}}>{' / '+props.getUom(productData.uom,true)}</span>:
                        null}

                    </span>
                )
            }
        }
    }
    return (
        <>
            <div className={styles['prod-desc']}>
                {props.searchText ? (
                    <SearchText
                        search={props.searchText}
                        text={productData.productName}
                        attachmentPresent={productData.attachmentPresent}
                        className="prod-title font-16"
                        containerClass= {styles['prod-title-vendor']}
                        readOnlyProduct={props.readOnlyProduct}
                    />
                ) :
                   <div className={styles['prod-title-vendor']}>
                        <p className='prod-title font-16 prod-vendor'>
                            {productData.productName}
                        </p>
                        {productData.attachmentPresent ?	
                            <span className={`icon-Gl_Attachment ${props.readOnlyProduct ? 'icon-padding' : ''}`}></span> : null 
                        } 
                     </div>   
                    }
                {productData.netWeight && productData.netWeight > 1 ? (
                    <p className={styles['prod-min-qty']+' '+styles['net-weight']}>
                        {Number(productData.netWeight) + ' ' + props.getUom(productData.netWeightUnit)}
                    </p>
                ):''}
                {productData.visibility == 'hide'?
                    <span className={styles['hidden-tag']+' '+(reverseAnimate?styles['reverse-animate']:'')}>
                        <i className="icon-glhide" />
                        <span style={{marginRight:'3px'}}>HIDDEN</span>
                    </span>:''}
                {productData.minOrderQuantity && productData.minOrderQuantity > 1 && productData.isReceiveEnquiry ? (
                    <p className={styles['prod-min-qty']}>
                        {'Min. Qty: '}
                        <span style={{color:'#414E59'}}>{productData.minOrderQuantity + ' ' + props.getUom(productData.uom)}</span>
                    </p>
            ) : null}
                <div className={`${styles['price']} ${styles['price-variant-container']}`}>
                    {displayPrice()}
                    {productData.variantCount > 1 ? <div className={styles['variant-count']}>{productData.variantCount} Variants</div> : null}
                </div>
            </div>
            {
                (!props.readOnlyProduct && !props.objectionableMode ) ? (<div className={styles['shareicon-holder']} onClick = {event => {
                        event.stopPropagation();
                        shareProductFunction()
                    }
                }>
                    <span className = {'icon-glshare'}></span>
                </div>) : null
            }
            {!props.readOnlyProduct && <div className='action-holder'>
                <div
                    className={styles['more-menu-parent']}
                    onClick={event => {
                        event.stopPropagation();
                    }}
                    onMouseDown={event => event.stopPropagation()}
                >
                    <MoreMenu
                        parentClass={styles['more-menu-holder']}
                        menuClass={styles['more-menu']}
                        list={list}
                        onToggle={props.onEditToggle}
                    />
                </div>
            </div>}
        </>
    );
};

const mapStateToProps = (state, props) => {
    return {
        productData: state.products.allProducts[props.variantId] || {},
        uomJsonMap: state.uom.uomJsonMap,
        session : state.session,
        objectionableProducts: state.products.vendorObjectionableProducts
    };
};

export default connect(mapStateToProps, {
    deleteProduct,
    showToastMessage,
    productUnderEdit,
    toggleProductVisibility
})(withRipple(ProductRowVendor));
